import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { SessionService } from './session.service';
//import { Http, Headers, RequestOptions, Response } from '@anuglar/http';
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';



@Injectable()
export class Service {
    protected static retry: number = 1;
    protected token: string;
    private static separator: string = '/';


    constructor(
        protected session: SessionService,
        protected http: HttpClient,

        protected config: AppConfig
    ) {}

    protected jwt() {
        // let headers = new Headers({
        //     'Content-Type': 'application/json',
        //     'Accept': 'application/json',
        //     'Access-Control-Allow-Headers': 'Content-Type',
        //     'Authorization': 'Token token=' + this.config.API_TOKEN
        // });


        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Access-Control-Allow-Headers': 'Content-Type',
            'Authorization': 'Token token=' + this.config.API_TOKEN
        });
        let options = {headers: headers};
        return options;

        //return new RequestOptions({ headers: headers });
    }

    protected set_data(data: any): any {
        this.set_token();

        return {ed: this.config.encrypt(JSON.stringify(data), this.token), t: this.token};
    }

    protected get_data(data: any): any {
        this.set_token();

        if (data.ed)
            return JSON.parse(this.config.decrypt(data, this.token));
    }

    protected format_url(module: string, url_attr?: any): string {
        this.set_token();
        let url: string = this.config.BASE_API_URL;
        url += (Service.separator + module);

        if (url_attr)
            url += (Service.separator + url_attr.toString());

        url += '?t=' + this.token;


        return url;
    }

    protected set_response(response: any): any {
        this.set_token();
        return JSON.parse(this.config.decrypt(response, this.token));
    }

    protected set_token(): void {
        const user: any = this.session.getItem('user');
        this.token = user && user.user ? user.user.token : this.config.API_TOKEN;
    }
}
